import CreativeService from '~/service/creativeService'
import AccountService from '~/service/accountService'

export default (ctx, inject) => {
  ctx.creativeService = new CreativeService(ctx)
  ctx.accountService = new AccountService(ctx)
  inject('creativeService', ctx.creativeService)
  inject('accountService', ctx.accountService)
}
